import { AUTH_TEXT } from '../constants';

export function ForbiddenPage() {
  return (
    <section className="flex flex-col gap-2">
      <h1 className="text-[23px] font-bold">{AUTH_TEXT.forbidden.title}</h1>
      <p className="text-[13px] text-text-2">{AUTH_TEXT.forbidden.message}</p>
    </section>
  );
}
